import axios from 'axios';
import BaseApi from './base-api';

class ChangeOrderTasksApi extends BaseApi {
  getChangeOrderTasks(workOrderId) {
    return axios
      .get(`${this.baseUrl}/work_orders/${workOrderId}/change_order_tasks`)
      .then((response) => {
        return {
          ok: true,
          changeOrderTasks: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  createChangeOrderTask(taskId, values) {
    let changeOrderTaskData = new FormData();
    changeOrderTaskData.append(
      'change_order_task[completion_date]',
      values.completionDate
    );
    changeOrderTaskData.append(
      'change_order_task[description]',
      values.description
    );

    if (values.images && values.images.length > 0) {
      values.images.forEach((image) => {
        let file = image.file;
        changeOrderTaskData.append(
          'change_order_task[images_attributes][][image]',
          file,
          file.name
        );
      });
    }

    if (values.changeOrderQuote) {
      changeOrderTaskData.append(
        'change_order_task[change_order_quote_attributes][create]',
        true
      );
    }

    return axios
      .post(
        `${this.baseUrl}/tasks/${taskId}/change_order_tasks`,
        changeOrderTaskData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      )
      .then((response) => {
        return {
          ok: true,
          changeOrderTask: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  deleteChangeOrderTask(changeOrderTaskId) {
    return axios
      .delete(`${this.baseUrl}/change_order_tasks/${changeOrderTaskId}`)
      .then((response) => {
        return {
          ok: true,
          changeOrderTasks: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  updateChangeOrderTask(changeOrderTaskId, values) {
    let imagesIndex = 0;
    let changeOrderTaskData = new FormData();
    changeOrderTaskData.append(
      'change_order_task[completion_date]',
      values.completionDate
    );
    changeOrderTaskData.append(
      'change_order_task[description]',
      values.description
    );

    if (values.images && values.images.length > 0) {
      values.images
        .filter((image) => image.file)
        .forEach((image) => {
          let file = image.file;
          changeOrderTaskData.append(
            `change_order_task[images_attributes][${imagesIndex}][image]`,
            file,
            file.name
          );
          imagesIndex++;
        });
    }

    if (values.imagesToDestroy && values.imagesToDestroy.length > 0) {
      values.imagesToDestroy.forEach((image) => {
        changeOrderTaskData.append(
          `change_order_task[images_attributes][${imagesIndex}][id]`,
          image.id
        );
        changeOrderTaskData.append(
          `change_order_task[images_attributes][${imagesIndex}][_destroy]`,
          true
        );
        imagesIndex++;
      });
    }

    return axios
      .put(
        `${this.baseUrl}/change_order_tasks/${changeOrderTaskId}`,
        changeOrderTaskData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      )
      .then((response) => {
        return {
          ok: true,
          changeOrderTask: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  updateChangeOrderQuote(changeOrderTaskId, values) {
    const apiPayload = {
      change_order_task: {
        change_order_quote_attributes: {
          id: values.id,
          estimate: values.estimate,
          value: values.value,
        },
      },
    };

    return axios
      .put(
        `${this.baseUrl}/change_order_tasks/${changeOrderTaskId}`,
        apiPayload
      )
      .then((response) => {
        return {
          ok: true,
          changeOrderTask: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  requestChangeOrderQuote(changeOrderTaskId, values) {
    const apiPayload = {
      change_order_task: {
        bid_due_date: values.bidDueDate,
      },
    };

    return axios
      .put(
        `${this.baseUrl}/change_order_tasks/${changeOrderTaskId}/request_quote`,
        apiPayload
      )
      .then((response) => {
        return {
          ok: true,
          changeOrderTask: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  submitChangeOrderQuote(changeOrderTaskId, values) {
    const apiPayload = {
      change_order_task: {
        change_order_quote_attributes: {
          id: values.id,
          start_date: values.startDate,
          days_of_duration: values.daysOfDuration,
          material_lead_days: values.materialLeadDays,
          estimate: values.estimate,
          description: values.description,
        },
      },
    };

    return axios
      .put(
        `${this.baseUrl}/change_order_tasks/${changeOrderTaskId}/submit_quote`,
        apiPayload
      )
      .then((response) => {
        return {
          ok: true,
          changeOrderTask: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  withdrawChangeOrderQuote(changeOrderTaskId) {
    return axios
      .put(
        `${this.baseUrl}/change_order_tasks/${changeOrderTaskId}/withdraw_quote`
      )
      .then((response) => {
        return {
          ok: true,
          changeOrderTask: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  withdrawChangeOrderQuoteRequest(changeOrderTaskId) {
    return axios
      .put(
        `${this.baseUrl}/change_order_tasks/${changeOrderTaskId}/delete_quote`
      )
      .then((response) => {
        return {
          ok: true,
          changeOrderTask: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }

  moveToAcr(workOrderId, changeOrderTaskIds) {
    const apiPayload = { change_order_task_ids: changeOrderTaskIds };

    return axios
      .put(
        `${this.baseUrl}/work_orders/${workOrderId}/change_order_tasks/move_to_acr`,
        apiPayload
      )
      .then((response) => {
        return {
          ok: true,
          changeOrderTasks: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export const changeOrderTasksApi = new ChangeOrderTasksApi();



// WEBPACK FOOTER //
// ./src/services/api/change-order-tasks-api.js